import(/* webpackMode: "eager" */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDL-Website\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Reveal"] */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDL-Website\\src\\components\\Reveal.tsx");
